import { render, staticRenderFns } from "./CarTwo.vue?vue&type=template&id=a883e990&scoped=true"
import script from "./CarTwo.vue?vue&type=script&lang=js"
export * from "./CarTwo.vue?vue&type=script&lang=js"
import style0 from "./CarTwo.vue?vue&type=style&index=0&id=a883e990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a883e990",
  null
  
)

export default component.exports